(ns common.debouncer)

(defn make-debouncer
  "Example of usage:

   (defn on-click-handler [my-id ^js event]
      ,,,)

   (defn my-reagent-component [my-id]
     (r/with-let [debounce (make-debouncer 1000)]
       [:div {:on-click (debounce on-click-handler my-id)}]))"
  [timeout-ms]
  (let [debouncer-state (atom nil)]
    (fn debounce [f & f-args]
      (fn debounced-fn-wrapper [& input-args]
        (when @debouncer-state (js/clearTimeout @debouncer-state))
        (reset! debouncer-state (js/setTimeout (fn call-debounced-fn [& _]
                                                 (reset! debouncer-state nil)
                                                 (apply f (concat f-args input-args)))
                                               timeout-ms))))))

(defn make-key-based-debouncer
  "A very specific debouncer which works on multiple channels in parallel, each one identified by a key.
   It also has a non-fixed debouncing delay which is specified each time the function is called."
  []
  (let [state (atom {})]
    (fn debounce [k delay-ms f]
      ;; If there was an existing previous timeout for this key, clear it.
      (when-some [timeout-id (get @state k)]
        (js/clearTimeout timeout-id)
        (swap! state dissoc k))

      ;; Set the function f to be called after the specified delay-ms, or immediately if delay-ms is zero.
      (if (zero? delay-ms)
        (f)
        (let [timeout-id (js/setTimeout (fn []
                                          (swap! state dissoc k)
                                          (f))
                                        delay-ms)]
          (swap! state assoc k timeout-id))))))

(defn make-throttler [timeout-ms]
  (let [timer-flag (atom nil)]
    (fn throttle [f & f-args]
      (fn throttled-fn-wrapper [& input-args]
        (when (nil? @timer-flag)
          (apply f (concat f-args input-args))
          (reset! timer-flag (js/setTimeout
                              (fn []
                                (reset! timer-flag nil))
                              timeout-ms)))))))
